const UserActionTypes = {
  ADD_USER: "ADD_USER",
  EDIT_USER: "EDIT_USER",
  GET_USER: "GET_USER",
  CHANGE_STATUS_USER: "CHANGE_STATUS_USER",
  CHANGE_CREATE_STATUS: "CHANGE_CREATE_STATUS",
  UPDATE_PROFILE_PHOTO: "UPDATE_PROFILE_PHOTO",
  UPDATE_COUNTRY: "UPDATE_COUNTRY",
  GET_BOT_ACCESS_USER: "GET_BOT_ACCESS_USER",
};

export default UserActionTypes;
